define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/wizard/ActionControllerMixin",
	"Apparel/PushColorwaysToStyleForm"
], function(array,declare,lang,Controller,PostRequest,ActionControllerMixin) {

	return declare([Controller,ActionControllerMixin], {
		onNextPage: function(/*csi.wizard.Widget*/wizard,
				 /*csi.wizard.Content*/currentPage,
				 /*csi.wizard.Content*/nextPage,
				 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			this.m_formData.setNode(null);
			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
		},

		getFormData: function() {
			// summary: make sure that at least one Style and Colorway is selected
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			return fd;
		},

		process: function() {
			// summary: issue request so as to be able to receive return value
			var	request = this.m_action.m_request;
			var fd = this.m_formData;

			this.setProgress();

			new PostRequest(request.m_module, request.m_operation)
				.addParameter("Colorways", fd.getFieldValue("Colorways"))
				.addParameter("AttributeGroups", fd.getFieldValue("AttributeGroups"))
				.addParameter("Styles", this.m_formData.getSelectedValue())
				.addParameter("AddToBOMs", fd.getFieldValue("AddToBOMs"))
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		}
    });
});
